export enum RebatesReSubmissionFileModelStatus {
	ProcessingProgress = 64,
	ProcessingFailed = 65,
	Processed = 66
}
